/**
 * Detect fn
 */
export default () => 'values' in Array.prototype
